import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash, FaCheck, FaTimes } from "react-icons/fa";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Button,
    Spinner,
    Input,
    CardFooter,
    FormGroup,
    Alert, 
    Modal, 
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
} from "reactstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import axiosInstance from "../../components/AxiosInstance"; 
import PerformanceTrend from "../Chillers/PerformanceTrend";
import InputPressureChart from "../Chillers/InputPressureChart";
import CompressorTables2 from "../Chillers/ChillerTable2";

const API_BASE_URL = "https://api.hvacsync.in/api";


const CompressorData = () => {
    const navigate = useNavigate();
    const { chillerId } = useParams();
    const location = useLocation();
    const machineId = location.state?.id; 
    const compressorName = location.state?.compname;
    const [chillerData, setChillerData] = useState(null);
    const [loadingCompressors, setLoadingCompressors] = useState(true);
    const [statusMessage, setStatusMessage] = useState({ type: '', message: '' });
   
    document.title = " Compressor Data | HVACSYNC ";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="mt-1">
                    {/* Header Section */}
                    

                    {/* Status Message */}
                    {statusMessage.message && (
                        <Alert color={statusMessage.type} className="mb-4">
                            {statusMessage.message}
                        </Alert>
                    )}

                    <h4>{compressorName}</h4>
                    {/* Performance and Tables Section */}
                    <PerformanceTrend  compressorId={machineId}/>

                    <InputPressureChart compressorId={machineId} />
                    <CompressorTables2 compressorId={machineId}/>
                    
                </Container>
            </div>

           
        </React.Fragment>
    );
};

export default CompressorData;